import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { SharePrivateContentExpirationDateSetting } from "~/components/SharePrivateContentModal/SharePrivateContentAdvancedBoardSettings/SharePrivateContentExpirationDateSetting";
import { SharePrivateContentPasscodeProtection } from "~/components/SharePrivateContentModal/SharePrivateContentAdvancedBoardSettings/SharePrivateContentPasscodeProtection";
import { SharePermissionSection } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePermissionSection";
import { ShareRequireAccountSetting } from "~/components/SharePrivateContentModal/SharePrivateContentSettings/ShareRequireAccountSetting";
export const ShareSecurityToggles = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, onShortUrlUpdate, isLoading } = param;
    return /*#__PURE__*/ _jsxs(SharePermissionSection, {
        title: "Security",
        children: [
            /*#__PURE__*/ _jsx(ShareRequireAccountSetting, {
                isLoading: isLoading,
                shortIdInfo: shortIdInfo,
                onShortUrlUpdate: onShortUrlUpdate
            }),
            /*#__PURE__*/ _jsx(SharePrivateContentPasscodeProtection, {
                shortIdInfo: shortIdInfo,
                onChangePasscode: (passcode)=>onShortUrlUpdate({
                        passcode
                    })
            }),
            /*#__PURE__*/ _jsx(SharePrivateContentExpirationDateSetting, {
                shortIdInfo: shortIdInfo,
                onChangeExpirationDate: (expirationDate)=>onShortUrlUpdate({
                        expirationDate
                    })
            })
        ]
    });
});
ShareSecurityToggles.displayName = "ShareSecurityToggles";
